import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const AuthGaurd = ({ user, children }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children ? children : <Outlet />;
};